export var UOMType;
(function (UOMType) {
    UOMType[UOMType["WEIGHT"] = 1] = "WEIGHT";
    UOMType[UOMType["COUNT"] = 2] = "COUNT";
    UOMType[UOMType["LENGTH"] = 3] = "LENGTH";
    UOMType[UOMType["AREA"] = 4] = "AREA";
    UOMType[UOMType["VOLUME"] = 5] = "VOLUME";
    UOMType[UOMType["TIME"] = 6] = "TIME";
})(UOMType || (UOMType = {}));
//# sourceMappingURL=uom-type.js.map